import { useAppSelector } from "../../../app/hooks";
import { scrollToId } from "../../../common/helpers/scrollToId";
import { JSX } from "react";
import { BovagTermsTypeEnum } from "../../../common/constants/BovagTermsTypeEnum";

const OverviewForm = (): JSX.Element | null => {
    const { dossier } = useAppSelector((state) => state.root);

    if (dossier?.person) {
        return (
            <div className="s-appointment__group border-color-primary">
                <div className="s-appointment__group__header">
                    <h1 className="s-appointment__group__title">
                        Jouw gegevens
                    </h1>
                    <button
                        type="button"
                        className="btn--info"
                        onClick={() => {
                            scrollToId("naw-form");
                        }}
                    >
                        <span>
                            <u>Wijzig</u>
                        </span>
                    </button>
                </div>
                <p>
                    <b>Volledige naam</b>
                </p>
                <p>
                    {dossier.person.first_name} {dossier.person.insertion}{" "}
                    {dossier.person.last_name}
                </p>
                <p>
                    <b>E-mailadres</b>
                </p>
                <p>{dossier.person.email}</p>
                <p>
                    <b>Mobiel nummer</b>
                </p>
                <p>{dossier.person.mobile_number}</p>
                {!!dossier.green_card_code && (
                    <>
                        <p>
                            <b>Groene kaart nummer</b>
                        </p>
                        <p>{dossier.green_card_code}</p>
                    </>
                )}
                {!!dossier.damage_number && (
                    <>
                        <p>
                            <b>Schadenummer</b>
                        </p>
                        <p>{dossier.damage_number}</p>
                    </>
                )}
                {dossier?.bovag_terms_type && (
                    <>
                        <p>
                            <b>Voertuiggebruik</b>
                        </p>
                        <p>
                            {dossier?.bovag_terms_type ===
                            BovagTermsTypeEnum.BUSINESS
                                ? "Zakelijk"
                                : "Particulier"}
                        </p>
                    </>
                )}
            </div>
        );
    }

    return null;
};

export default OverviewForm;
